<template>
  <v-app>
    <core-app-bar />

    <core-drawer />

    <dashboard-review-dependents-view />

    <core-footer />

  </v-app>
</template>

<script>
export default {
  name: 'ReviewDependents',

  components: {
    CoreAppBar: () => import('../components/core/AppBar'),
    CoreDrawer: () => import('../components/core/Drawer'),
    DashboardReviewDependentsView: () => import('../components/dashboards/ReviewDependentsView'),
    CoreFooter: () => import('../components/core/Footer'),
  },

  data: () => ({
    expandOnHover: false,
  }),
}
</script>
